import React, { useState } from 'react';
import {
  TableRow,
  TableCell,
  Avatar,
  IconButton
} from '@mui/material';
import { DateTime } from 'luxon';
import { RemoveCircleOutline } from '@mui/icons-material';
import { RemoveSuperAdminModal } from 'modules/components/layer17';


export type SuperAdminTableRowProps = {
  id: string;
  fullName: string;
  createdDate: DateTime;
  profileUrl: string;
  phoneNumber: string;
  email: string;
  isActive: boolean;
};

export const FC = (props: SuperAdminTableRowProps) => {
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  return (
    <TableRow
      content='list'
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <TableCell
        variant='firstRounded'
      >
        <Avatar
          src={props.profileUrl}
        />
        {props.fullName}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.createdDate.toFormat('DDDD')}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.phoneNumber}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.email}
      </TableCell>
      <TableCell
        variant='lastRounded'
      >
        <IconButton
          onClick={() => setIsVisible(() => true)}
        >
          <RemoveCircleOutline
            color='error'
          />

        </IconButton>
      </TableCell>
      {isVisible && (
        <RemoveSuperAdminModal.FC
          id={props.id}
          isVisible
          handleClose={() => setIsVisible(() => false)}


        />
      )}
    </TableRow>

  );
};
